import React from "react";
import { WithContext as ReactTags } from 'react-tag-input';

const RTag = React.forwardRef((props, ref) => (
  <div className="form-control-select">
    <ReactTags
      classNames={{
        tags: '',
        tagInput: 'mb-2 form-control-wrap',
        tagInputField: `form-control`,
        tag: 'lh-lg border border-primary p-1 rounded mr-1',
        remove: `btn btn-link p-0 ml-2`
      }}
      inputFieldPosition="top"
      placeholder="Thêm nhãn"
      classNamePrefix="react-select"
      {...props}
      ref={ref}
    />
  </div>
));

export default RTag;
